import { service } from "./api-service";

export function getGeneralOptions() {
  return service({
    url: "/general/options",
    method: "get",
  });
}
